import { Component, ElementRef, Injector, Type } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxBaseBlotterContextMenu } from "../../../bfx-base-blotter/bfx-base-blotter-contextmenu";
import { BmarkClientOrdersContextMenuService } from "./services/bmark-client-orders-context-menu.service";
import { animate, state, style, transition, trigger } from "@angular/animations";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BenchmarkDataPrimaryLookupService } from "shared/cubiq-services";
import { BmarkClientOrdersContextMenuItem } from "./models/bmark-client-orders-context-menu.models";
@Component({
  selector: "bmark-client-orders-context-menu",
  templateUrl: "./html/bmark-client-orders-context-menu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  standalone: false,
})
export class BmarkClientOrdersContextMenuComponent extends BfxBaseBlotterContextMenu<CubiqTS.OrderDataImpl> {
  constructor(
    injector: Injector,
    lookupService: BenchmarkDataPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected getMenuServiceType(): Type<BmarkClientOrdersContextMenuService> {
    return BmarkClientOrdersContextMenuService;
  }

  public isItemEnabled(item: BmarkClientOrdersContextMenuItem) {
    if (item == null) {
      return false;
    }
    return item.state.enabled;
  }

  public selectedMenuItem(item: BmarkClientOrdersContextMenuItem, event?: any) {
    if (this.isItemEnabled(item)) {
      (this.menuService as BmarkClientOrdersContextMenuService).fireActionEvent(
        item.actionId,
        this.currentLadderBlotter,
        null,
        null,
        item.state,
        null,
        null,
        event,
      );
      if (item.clearSelection) {
        this.currentLadderBlotter?.gridOptions?.api?.deselectAll();
        this.currentLadderBlotter?.onSelectionChanged([]);
      }
      this.hideMenu();
    }
  }
}
